import React from "react";
import { Box, Typography, Grid, Paper, Stack } from "@mui/material";

const InformationSection = () => {
  const infoItems = [
    {
      title: "Contacts:",
      description:
        "A contact refers to a record in the Contact Module. Once you exceed the allowed contact limit, additional charges will apply.",
      glassStyle: {
        background: "rgba(255, 245, 157, 0.1)", // Light yellow tint
        border: "1px solid rgba(255, 245, 157, 0.3)",
        backdropFilter: "blur(6px)",
      },
    },
    {
      title: "Interactions:",
      description:
        "Interactions refer to the total number of incoming and outgoing messages on your account across all connected channels.",
      glassStyle: {
        background: "rgba(129, 199, 132, 0.1)", // Light green tint
        border: "1px solid rgba(129, 199, 132, 0.3)",
        backdropFilter: "blur(8px)",
      },
    },
    {
      title: "Add-ons:",
      description:
        "Add-ons such as WhatsApp Managed Services, Zapier, Zoho CRM, and Zendesk are available at additional cost.",
      glassStyle: {
        background: "rgba(128, 216, 255, 0.1)", // Light blue tint
        border: "1px solid rgba(128, 216, 255, 0.3)",
        backdropFilter: "blur(5px)",
      },
    },
    {
      title: "API Access:",
      description:
        "API Access offers developers the tools to seamlessly connect Picky Assist with third-party platforms and services.",
      glassStyle: {
        background: "rgba(206, 147, 216, 0.1)", // Light purple tint
        border: "1px solid rgba(206, 147, 216, 0.3)",
        backdropFilter: "blur(10px)",
      },
    },
  ];

  return (
    <Stack
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          padding: 2,
          backgroundColor: "#fff",
          width: { xl: "70%", lg: "90%" },
        }}
      >
        <Paper
          elevation={3}
          sx={{
            backgroundColor: "#FFFBEA",
            padding: 2,
            marginBottom: 6,
            marginTop: 0,
            borderRadius: 2,
          }}
        >
          <Typography
            variant="body1"
            sx={{
              display: { xs: "none", sm: "flex" },
              alignItems: "center",
              gap: 1,
              fontWeight: 500,
              color: "#333",
              fontSize: {xl: "20px",lg: "20px", md: "20px", sm: "18px", xs: "14px"},
              lineHeight: {lg: '31px', xl: '31px', md: '20px', xs: '20px', sm: '20px'}
            }}
          >
            The mentioned prices are applicable for self-onboarding only. If you
            need assistance with advanced CRM setup or integration with
            third-party applications, a one-time onboarding fee will be charged
            starting at ₹50 per hour. Please note, WhatsApp conversation charges
            are not included and will vary based on your actual usage.
          </Typography>

          <Typography
            variant="body1"
            sx={{
              display: { xs: "flex", sm: "none" },
              alignItems: "center",
              gap: 1,
              fontWeight: 500,
              color: "#333",
            }}
          >
            Prices are for self-onboarding. Advanced CRM setup or third-party
            integration starts at ₹50/hr. WhatsApp charges vary by usage.
          </Typography>
        </Paper>

        <Grid
          container
          spacing={2}
          sx={{
            flexDirection: {
              xs: "column",
              md: "row",
              sm: "row",
              lg: "row",
              xl: "row",
            },
          }}
        >
          {infoItems.map((item, index) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={3}
              key={index}
              sx={{
                display: "flex",
                alignItems: "flex-start",
                gap: 1,
                flexDirection: "row",
              }}
            >
              <Box
                sx={{
                  ...item.glassStyle,
                  padding: 2,
                  borderRadius: 2,
                  width: "100%",
                  boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
                }}
              >
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  gutterBottom
                  sx={{
                    // border: "1px solid red",
                    fontSize: {xs: "14px", sm: "20px", md: "20px", lg: "18px", xl: "18px" },
                  }}
                >
                  {item.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    // border: "1px solid red",
                    fontSize: {xs: "12px", sm: "18px", md: "18px", lg: "16px", xl: "16px" },
                    color: "#333",
                  }}
                >
                  {item.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Stack>
  );
};

export default InformationSection;